import React from 'react';
import Switch from '@rio-cloud/rio-uikit/lib/es/Switch';
import OverlayTrigger from '@rio-cloud/rio-uikit/lib/es/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/lib/es/Tooltip';
import { FormattedMessage } from 'react-intl';

interface DeliverableVehicleSpeedFormItemProps {
    model: any;
    onChange: (value:  React.ChangeEvent<HTMLInputElement>) => void;
}

const DeliverableVehicleSpeedFormItem: React.FC<DeliverableVehicleSpeedFormItemProps> = ({ model, onChange }) => {
    return (
        <div className="form-group form-group-description">
            <label className="control-label">
                <FormattedMessage id="intl-msg:vehicleSpeed"/>
            </label>
            <OverlayTrigger
                key={1}
                placement={'right-start'}
                overlay={
                    <Tooltip id='tooltip' allowOnTouch>
                        <FormattedMessage id={'intl-msg:vehicleSpeed.tooltip'}/>
                    </Tooltip>
                }
            >
                <span className={'rioglyph rioglyph-exclamation-sign margin-left-5 text-color-info '}/>
            </OverlayTrigger>
            <FormattedMessage id="intl-msg:vehicleSpeed.placeholder">
                {placeHolder =>
                    <input type="number" className="form-control"
                           value={model.vehicleSpeed}
                           placeholder={placeHolder}
                           onChange={(v)=> onChange(v)}/>
                }
            </FormattedMessage>
        </div>    );
};

export default DeliverableVehicleSpeedFormItem;
